export const createAuthSlice = (set, get) => ({
  // Auth state
  user: null,
  isAuthenticated: false,
  error: null,
  language: 'en',

  // Auth actions
  login: async (token) => {

    try {
      const response = await fetch('/api/auth/status', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'user-token': token,
        },
        credentials: 'include',
      })


      if (response.ok) {
        const data = await response.json()

        console.log('Login successful, updating store with:', data)

        set({
          user: data,
          isAuthenticated: true,
          error: null
        })
        return { success: true, user: data }
      } else {
        set({
          user: null,
          isAuthenticated: false,
          error: 'Login failed'
        })
        return { success: false, error: 'Login failed' }
      }
    } catch (err) {
      set({
        error: 'Network error. Please try again.'
      })
      return { success: false, error: 'Network error' }
    }
  },

  logout: async () => {
    try {
      await fetch('/api/auth/logout', {
        method: 'GET',
        credentials: 'include',
      })
    } catch (err) {
      console.error('Logout error:', err)
    } finally {
      set({
        user: null,
        isAuthenticated: false,
        error: null
      })
    }
  },

  checkAuthStatus: async () => {
    try {
      
      const response = await fetch('/api/auth/status', {
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        }
      })

      if (response.ok) {
        const data = await response.json()

        console.log('Login successful, updating store with:', data.user)

        set({
          user: data,
          isAuthenticated: true,
          error: null
        })
        return { success: true, user: data }
      } else {
        set({
          isAuthenticated: false,
          user: null,
          error: 'Login failed'
        })
        return { success: false, error: 'Login failed' }
      }
    } catch (err) {
      console.log('Auth status check failed, assuming not authenticated:', err)
      set({
        user: null,
        isAuthenticated: false,
      })
    }
  },

  clearError: () => {
    set({ error: null })
  },

  setLanguage: (language) => {
    set({ language })
  }
})
